export default __webpack_public_path__ + "static/media/icon_HT.1b159f13.svg";